import * as tslib_1 from "tslib";
import datapoints from './datapoints';
import selectNodeInFolderForest from './selectNodeInFolderForest';
import onAfterSelectingNode from './helpers/onAfterSelectingNode';
import { lazyLoadGroupAction, lazyOnAfterNewGroupSelected, lazyOnAfterGroupDetailsSucceeded, } from 'owa-group-shared-actions';
import { lazySetGroupHeaderCallbacks } from 'owa-group-header-actions';
import { lazySetGroupFilesHubCallbacks } from 'owa-group-fileshub-init';
import { folderForestStore, getSelectedNode } from 'owa-mail-folder-forest-store';
import { action, select } from 'satcheljs/lib/legacy';
/**
 * Switch Group action, extracted to accurately track the SwitchGroup CTQ
 * by returning a promise for selecting the node
 * @param groupId the groupId
 */
var switchGroup = action('switchGroup', datapoints.switchGroupDatapoint)(function switchGroup(groupId, treeType) {
    return selectGroupInternal(groupId, treeType);
});
/**
 * NavigateFromMeToWe action, extracted to accurately track the
 * NavigateFromMeToWe CTQ by returning a promise for selecting the node
 * @param groupId the groupId
 */
var navigateFromMeToWe = action('navigateFromMeToWe', datapoints.navigateFromMeToWeDatapoint)(function navigateFromMeToWe(groupId, treeType) {
    return selectGroupInternal(groupId, treeType);
});
/**
 * General select group action
 * @param groupId
 */
var selectGroupInternal = action('selectGroupInternal')(function selectGroupInternal(groupId, treeType) {
    return selectNodeInFolderForest({
        id: groupId,
        type: 2 /* Group */,
        treeType: treeType,
    });
});
/**
 * Select a group
 * @param groupId the groupId
 */
export default action('selectGroup')(select({
    selectedNode: function () { return folderForestStore.selectedNode; },
})(function selectGroup(groupId, treeType, onLoadGroupSuccess, onLoadGroupError, state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var currentNode, groupLoadPromises, onSuccess_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    currentNode = getSelectedNode();
                    groupLoadPromises = Promise.resolve();
                    if (currentNode.id && currentNode.id.toLowerCase() == groupId.toLowerCase()) {
                        // Do not perform the rest of selecting group logic when
                        // user navigates to the node with the same id
                        // (Switch between favorites and groups list in the left nav)
                        state.selectedNode.treeType = treeType;
                    }
                    else {
                        // route the action based on whether or not it should be logged
                        // as switchGroup or navigateFromMeToWe
                        if (currentNode.type == 2 /* Group */) {
                            switchGroup(groupId, treeType);
                        }
                        else {
                            navigateFromMeToWe(groupId, treeType);
                        }
                        onSuccess_1 = function () {
                            lazyOnAfterGroupDetailsSucceeded.importAndExecute(groupId);
                            if (onLoadGroupSuccess) {
                                onLoadGroupSuccess();
                            }
                        };
                        groupLoadPromises = Promise.all([
                            lazyLoadGroupAction.import().then(function (loadGroupAction) {
                                loadGroupAction(groupId, onSuccess_1, onLoadGroupError);
                            }),
                            lazySetGroupHeaderCallbacks.importAndExecute(),
                            lazySetGroupFilesHubCallbacks.importAndExecute(),
                        ]).then(function () { return lazyOnAfterNewGroupSelected.importAndExecute(groupId); });
                    }
                    // Called after selecting same/different group
                    // #15945 - We should try to merge SelectFolder, SelectPersona, SelectGroup logic and move this method into a common place
                    onAfterSelectingNode();
                    return [4 /*yield*/, groupLoadPromises];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=selectGroup.js.map